export function getFilenameFromUrl(url: string) {
  if (url) {
    const filename = url.substring(url.lastIndexOf("/") + 1);
    const prettyfiedFileName = filename.replace(/[#?].*$/, "");
    return removeTimestampFromFileName(prettyfiedFileName);
  }
  return "";
}

export function getFileExtensionFromUrl(url: string) {
  return getFilenameFromUrl(url)
    .split(".")
    .pop();
}

export function removeTimestampFromFileName(fileName: string) {
  return fileName.replace(/(_T\d+\.)/g, ".");
}